export default "__VITE_ASSET__C7YwU7Nb__"